module.exports = __webpack_public_path__ + "kibervarnost/media/ne-verjemi-velikim-obljubam.53910ed7.mp4";